var _path, _g, _path2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlanesAccion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1437_74862",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 9.94668V11.1467H10.8V9.94668H9.6ZM1.2 1.54668V2.74668H2.4V1.54668H1.2ZM1.2 9.94668V11.1467H2.4V9.94668H1.2ZM3.6 1.54668H9V2.74668H3.6V3.94668H0V0.34668H3.6V1.54668ZM8.4 9.94668V8.74668H9.6V3.34668H10.8V8.74668H12V12.3467H8.4V11.1467H3.6V12.3467H0V8.74668H3.6V9.94668H8.4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1437_74862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 -1.15332H-1.5V13.8467H13.5V-1.15332Z",
    fill: "#7B7B7B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1437_74862",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 4,
    height: 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2004 0.34668C11.1934 0.34668 12.0004 1.15368 12.0004 2.14668C12.0004 3.13968 11.1934 3.94668 10.2004 3.94668C9.20739 3.94668 8.40039 3.13968 8.40039 2.14668C8.40039 1.15368 9.20739 0.34668 10.2004 0.34668ZM10.2004 1.54668C9.87039 1.54668 9.60039 1.81668 9.60039 2.14668C9.60039 2.47668 9.87039 2.74668 10.2004 2.74668C10.5304 2.74668 10.8004 2.47668 10.8004 2.14668C10.8004 1.81668 10.5304 1.54668 10.2004 1.54668Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1437_74862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5004 -1.15332H6.90039V5.44668H13.5004V-1.15332Z",
    fill: "#7B7B7B"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanesAccion);
export default __webpack_public_path__ + "static/media/icon-planes-accion.5f0c124c.svg";
export { ForwardRef as ReactComponent };